import { TStats } from '@sifrovacihra/shared-ui';

export const stats2024Z = {
    "cyphers": [
        {
            "Id": 1,
            "code": null,
            "name": null,
            "type": "S",
            "message": null,
            "points": 0,
            "cathegory": null,
            "hasPdf": false,
            "solution": false,
            "solved": false,
            "helps": null,
            "stars": 0.0,
            "votes": 0,
            "teams": 0
        },
        {
            "Id": 2,
            "code": null,
            "name": null,
            "type": "C",
            "message": null,
            "points": 0,
            "cathegory": null,
            "hasPdf": false,
            "solution": false,
            "solved": false,
            "helps": null,
            "stars": 0.0,
            "votes": 0,
            "teams": 0
        },
        {
            "Id": 3,
            "code": null,
            "name": null,
            "type": "C",
            "message": null,
            "points": 0,
            "cathegory": null,
            "hasPdf": false,
            "solution": false,
            "solved": false,
            "helps": null,
            "stars": 0.0,
            "votes": 0,
            "teams": 0
        },
        {
            "Id": 4,
            "code": null,
            "name": null,
            "type": "C",
            "message": null,
            "points": 0,
            "cathegory": null,
            "hasPdf": false,
            "solution": false,
            "solved": false,
            "helps": null,
            "stars": 0.0,
            "votes": 0,
            "teams": 0
        },
        {
            "Id": 5,
            "code": null,
            "name": null,
            "type": "C",
            "message": null,
            "points": 0,
            "cathegory": null,
            "hasPdf": false,
            "solution": false,
            "solved": false,
            "helps": null,
            "stars": 0.0,
            "votes": 0,
            "teams": 0
        },
        {
            "Id": 6,
            "code": null,
            "name": null,
            "type": "C",
            "message": null,
            "points": 0,
            "cathegory": null,
            "hasPdf": false,
            "solution": false,
            "solved": false,
            "helps": null,
            "stars": 0.0,
            "votes": 0,
            "teams": 0
        },
        {
            "Id": 7,
            "code": null,
            "name": null,
            "type": "C",
            "message": null,
            "points": 0,
            "cathegory": null,
            "hasPdf": false,
            "solution": false,
            "solved": false,
            "helps": null,
            "stars": 0.0,
            "votes": 0,
            "teams": 0
        },
        {
            "Id": 8,
            "code": null,
            "name": null,
            "type": "C",
            "message": null,
            "points": 0,
            "cathegory": null,
            "hasPdf": false,
            "solution": false,
            "solved": false,
            "helps": null,
            "stars": 0.0,
            "votes": 0,
            "teams": 0
        },
        {
            "Id": 9,
            "code": null,
            "name": null,
            "type": "F",
            "message": null,
            "points": 0,
            "cathegory": null,
            "hasPdf": false,
            "solution": false,
            "solved": false,
            "helps": null,
            "stars": 0.0,
            "votes": 0,
            "teams": 0
        }
    ],
    "teams": [
        {
            "Id": 10,
            "Name": "Studny",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 9,
                "message": null,
                "Status": 0,
                "totalTime": "01:34:37",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 58,
            "Name": "Nevyšlo počasí",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 9,
                "message": null,
                "Status": 0,
                "totalTime": "01:42:58",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 23,
            "Name": "ó náš pán krákorá",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 9,
                "message": null,
                "Status": 0,
                "totalTime": "01:50:27",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 11,
            "Name": "Karel a jeho mládí",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 9,
                "message": null,
                "Status": 0,
                "totalTime": "02:12:56",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 9,
            "Name": "Parťačky",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 9,
                "message": null,
                "Status": 0,
                "totalTime": "02:19:07",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 52,
            "Name": "Vypálit Staňkovský rybník",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 9,
                "message": null,
                "Status": 0,
                "totalTime": "02:22:37",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 6,
            "Name": "Enigma quartet breakers",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 9,
                "message": null,
                "Status": 0,
                "totalTime": "02:24:41",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 42,
            "Name": "Hejno racků",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 9,
                "message": null,
                "Status": 0,
                "totalTime": "02:32:47",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 41,
            "Name": "svištíci",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 9,
                "message": null,
                "Status": 0,
                "totalTime": "02:35:03",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 26,
            "Name": "Jezvinky",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 9,
                "message": null,
                "Status": 0,
                "totalTime": "02:35:06",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 35,
            "Name": "Dvě sestry",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 9,
                "message": null,
                "Status": 0,
                "totalTime": "02:35:51",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 50,
            "Name": "Žaludi a bukvice",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 9,
                "message": null,
                "Status": 0,
                "totalTime": "02:38:08",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 49,
            "Name": "Zrzkova patrola",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 9,
                "message": null,
                "Status": 0,
                "totalTime": "02:53:07",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 7,
            "Name": "Dobrý ročník",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 9,
                "message": null,
                "Status": 0,
                "totalTime": "02:53:32",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 1,
            "Name": "#DEKA",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 9,
                "message": null,
                "Status": 0,
                "totalTime": "03:03:09",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 29,
            "Name": "Čendáno",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 9,
                "message": null,
                "Status": 0,
                "totalTime": "03:04:08",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 13,
            "Name": "Svatobor",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 9,
                "message": null,
                "Status": 0,
                "totalTime": "03:11:49",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 38,
            "Name": "Duhový bobci",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 9,
                "message": null,
                "Status": 0,
                "totalTime": "03:17:01",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 59,
            "Name": "Tříděný odpad",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 9,
                "message": null,
                "Status": 0,
                "totalTime": "03:19:07",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 27,
            "Name": "Kapybary",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 9,
                "message": null,
                "Status": 0,
                "totalTime": "03:27:18",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 57,
            "Name": "Mandelíci",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 9,
                "message": null,
                "Status": 0,
                "totalTime": "03:28:52",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 54,
            "Name": "Team Curious",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 9,
                "message": null,
                "Status": 0,
                "totalTime": "03:34:22",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 30,
            "Name": "Havran",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 9,
                "message": null,
                "Status": 0,
                "totalTime": "03:35:47",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 33,
            "Name": "Tradiční Trio",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 9,
                "message": null,
                "Status": 0,
                "totalTime": "03:43:10",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 36,
            "Name": "Černé kočičky",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 9,
                "message": null,
                "Status": 0,
                "totalTime": "05:22:06",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 12,
            "Name": "Mazaný housky",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 0,
                "message": null,
                "Status": 0,
                "totalTime": "00:00:00",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        },
        {
            "Id": 60,
            "Name": "Valešovi",
            "Phone": null,
            "Password": null,
            "Type": 0,
            "GameInfo": {
                "cypher": 0,
                "message": null,
                "Status": 0,
                "totalTime": "00:00:00",
                "points": 0
            },
            "Players": null,
            "Cathegory": null,
            "Payed": false
        }
    ],
    "teamCyphers": [
        {
            "id_team": 3,
            "id_cypher": 1,
            "time": "2024-05-11T08:12:18",
            "minusPoints": 0
        },
        {
            "id_team": 50,
            "id_cypher": 1,
            "time": "2024-05-11T09:04:54",
            "minusPoints": 0
        },
        {
            "id_team": 56,
            "id_cypher": 1,
            "time": "2024-05-11T09:10:12",
            "minusPoints": 0
        },
        {
            "id_team": 15,
            "id_cypher": 1,
            "time": "2024-05-11T09:10:52",
            "minusPoints": 0
        },
        {
            "id_team": 2,
            "id_cypher": 1,
            "time": "2024-05-11T09:11:50",
            "minusPoints": 0
        },
        {
            "id_team": 54,
            "id_cypher": 1,
            "time": "2024-05-11T09:13:16",
            "minusPoints": 0
        },
        {
            "id_team": 26,
            "id_cypher": 1,
            "time": "2024-05-11T09:14:36",
            "minusPoints": 0
        },
        {
            "id_team": 28,
            "id_cypher": 1,
            "time": "2024-05-11T09:15:25",
            "minusPoints": 0
        },
        {
            "id_team": 39,
            "id_cypher": 1,
            "time": "2024-05-11T09:15:27",
            "minusPoints": 0
        },
        {
            "id_team": 51,
            "id_cypher": 1,
            "time": "2024-05-11T09:15:30",
            "minusPoints": 0
        },
        {
            "id_team": 25,
            "id_cypher": 1,
            "time": "2024-05-11T09:20:26",
            "minusPoints": 0
        },
        {
            "id_team": 4,
            "id_cypher": 2,
            "time": "2024-05-11T09:22:07",
            "minusPoints": 0
        },
        {
            "id_team": 55,
            "id_cypher": 2,
            "time": "2024-05-11T09:23:59",
            "minusPoints": 0
        },
        {
            "id_team": 20,
            "id_cypher": 1,
            "time": "2024-05-11T09:27:29",
            "minusPoints": 0
        },
        {
            "id_team": 20,
            "id_cypher": 2,
            "time": "2024-05-11T09:27:35",
            "minusPoints": 0
        },
        {
            "id_team": 23,
            "id_cypher": 2,
            "time": "2024-05-11T09:29:12",
            "minusPoints": 0
        },
        {
            "id_team": 49,
            "id_cypher": 1,
            "time": "2024-05-11T09:29:27",
            "minusPoints": 0
        },
        {
            "id_team": 51,
            "id_cypher": 2,
            "time": "2024-05-11T09:30:40",
            "minusPoints": 0
        },
        {
            "id_team": 58,
            "id_cypher": 1,
            "time": "2024-05-11T09:31:27",
            "minusPoints": 0
        },
        {
            "id_team": 58,
            "id_cypher": 2,
            "time": "2024-05-11T09:31:42",
            "minusPoints": 0
        },
        {
            "id_team": 22,
            "id_cypher": 2,
            "time": "2024-05-11T09:32:28",
            "minusPoints": 0
        },
        {
            "id_team": 28,
            "id_cypher": 2,
            "time": "2024-05-11T09:32:36",
            "minusPoints": 0
        },
        {
            "id_team": 4,
            "id_cypher": 3,
            "time": "2024-05-11T09:33:18",
            "minusPoints": 0
        },
        {
            "id_team": 10,
            "id_cypher": 3,
            "time": "2024-05-11T09:33:22",
            "minusPoints": 0
        },
        {
            "id_team": 11,
            "id_cypher": 2,
            "time": "2024-05-11T09:34:47",
            "minusPoints": 0
        },
        {
            "id_team": 16,
            "id_cypher": 2,
            "time": "2024-05-11T09:34:52",
            "minusPoints": 0
        },
        {
            "id_team": 18,
            "id_cypher": 2,
            "time": "2024-05-11T09:36:32",
            "minusPoints": 0
        },
        {
            "id_team": 31,
            "id_cypher": 2,
            "time": "2024-05-11T09:38:21",
            "minusPoints": 0
        },
        {
            "id_team": 56,
            "id_cypher": 3,
            "time": "2024-05-11T09:38:56",
            "minusPoints": 0
        },
        {
            "id_team": 40,
            "id_cypher": 3,
            "time": "2024-05-11T09:39:17",
            "minusPoints": 0
        },
        {
            "id_team": 10,
            "id_cypher": 4,
            "time": "2024-05-11T09:40:14",
            "minusPoints": 0
        },
        {
            "id_team": 42,
            "id_cypher": 2,
            "time": "2024-05-11T09:40:15",
            "minusPoints": 0
        },
        {
            "id_team": 4,
            "id_cypher": 4,
            "time": "2024-05-11T09:41:11",
            "minusPoints": 0
        },
        {
            "id_team": 39,
            "id_cypher": 3,
            "time": "2024-05-11T09:41:24",
            "minusPoints": 0
        },
        {
            "id_team": 25,
            "id_cypher": 2,
            "time": "2024-05-11T09:41:50",
            "minusPoints": 0
        },
        {
            "id_team": 27,
            "id_cypher": 1,
            "time": "2024-05-11T09:41:50",
            "minusPoints": 0
        },
        {
            "id_team": 51,
            "id_cypher": 3,
            "time": "2024-05-11T09:41:53",
            "minusPoints": 0
        },
        {
            "id_team": 28,
            "id_cypher": 3,
            "time": "2024-05-11T09:42:03",
            "minusPoints": 0
        },
        {
            "id_team": 27,
            "id_cypher": 2,
            "time": "2024-05-11T09:42:12",
            "minusPoints": 0
        },
        {
            "id_team": 17,
            "id_cypher": 2,
            "time": "2024-05-11T09:46:22",
            "minusPoints": 0
        },
        {
            "id_team": 2,
            "id_cypher": 2,
            "time": "2024-05-11T09:47:31",
            "minusPoints": 0
        },
        {
            "id_team": 40,
            "id_cypher": 4,
            "time": "2024-05-11T09:50:31",
            "minusPoints": 0
        },
        {
            "id_team": 26,
            "id_cypher": 2,
            "time": "2024-05-11T09:51:32",
            "minusPoints": 0
        },
        {
            "id_team": 22,
            "id_cypher": 3,
            "time": "2024-05-11T09:51:33",
            "minusPoints": 0
        },
        {
            "id_team": 58,
            "id_cypher": 4,
            "time": "2024-05-11T09:54:53",
            "minusPoints": 0
        },
        {
            "id_team": 13,
            "id_cypher": 2,
            "time": "2024-05-11T09:54:56",
            "minusPoints": 0
        },
        {
            "id_team": 30,
            "id_cypher": 3,
            "time": "2024-05-11T09:55:19",
            "minusPoints": 0
        },
        {
            "id_team": 9,
            "id_cypher": 3,
            "time": "2024-05-11T09:55:30",
            "minusPoints": 0
        },
        {
            "id_team": 27,
            "id_cypher": 3,
            "time": "2024-05-11T09:55:41",
            "minusPoints": 0
        },
        {
            "id_team": 31,
            "id_cypher": 3,
            "time": "2024-05-11T09:55:54",
            "minusPoints": 0
        },
        {
            "id_team": 53,
            "id_cypher": 2,
            "time": "2024-05-11T09:55:58",
            "minusPoints": 0
        },
        {
            "id_team": 32,
            "id_cypher": 3,
            "time": "2024-05-11T09:56:28",
            "minusPoints": 0
        },
        {
            "id_team": 15,
            "id_cypher": 2,
            "time": "2024-05-11T09:56:56",
            "minusPoints": 0
        },
        {
            "id_team": 4,
            "id_cypher": 5,
            "time": "2024-05-11T09:56:59",
            "minusPoints": 0
        },
        {
            "id_team": 42,
            "id_cypher": 3,
            "time": "2024-05-11T09:57:40",
            "minusPoints": 0
        },
        {
            "id_team": 29,
            "id_cypher": 3,
            "time": "2024-05-11T09:58:13",
            "minusPoints": 0
        },
        {
            "id_team": 56,
            "id_cypher": 5,
            "time": "2024-05-11T10:00:06",
            "minusPoints": 0
        },
        {
            "id_team": 1,
            "id_cypher": 4,
            "time": "2024-05-11T10:00:58",
            "minusPoints": 0
        },
        {
            "id_team": 18,
            "id_cypher": 3,
            "time": "2024-05-11T10:02:05",
            "minusPoints": 0
        },
        {
            "id_team": 40,
            "id_cypher": 5,
            "time": "2024-05-11T10:02:53",
            "minusPoints": 0
        },
        {
            "id_team": 49,
            "id_cypher": 3,
            "time": "2024-05-11T10:03:48",
            "minusPoints": 0
        },
        {
            "id_team": 35,
            "id_cypher": 3,
            "time": "2024-05-11T10:04:19",
            "minusPoints": 0
        },
        {
            "id_team": 23,
            "id_cypher": 5,
            "time": "2024-05-11T10:04:37",
            "minusPoints": 0
        },
        {
            "id_team": 11,
            "id_cypher": 4,
            "time": "2024-05-11T10:04:42",
            "minusPoints": 0
        },
        {
            "id_team": 2,
            "id_cypher": 3,
            "time": "2024-05-11T10:04:59",
            "minusPoints": 0
        },
        {
            "id_team": 26,
            "id_cypher": 3,
            "time": "2024-05-11T10:06:07",
            "minusPoints": 0
        },
        {
            "id_team": 34,
            "id_cypher": 2,
            "time": "2024-05-11T10:06:52",
            "minusPoints": 0
        },
        {
            "id_team": 22,
            "id_cypher": 4,
            "time": "2024-05-11T10:07:40",
            "minusPoints": 0
        },
        {
            "id_team": 57,
            "id_cypher": 2,
            "time": "2024-05-11T10:07:49",
            "minusPoints": 0
        },
        {
            "id_team": 31,
            "id_cypher": 4,
            "time": "2024-05-11T10:07:56",
            "minusPoints": 0
        },
        {
            "id_team": 30,
            "id_cypher": 4,
            "time": "2024-05-11T10:07:58",
            "minusPoints": 0
        },
        {
            "id_team": 51,
            "id_cypher": 5,
            "time": "2024-05-11T10:07:59",
            "minusPoints": 0
        },
        {
            "id_team": 28,
            "id_cypher": 5,
            "time": "2024-05-11T10:08:01",
            "minusPoints": 0
        },
        {
            "id_team": 58,
            "id_cypher": 5,
            "time": "2024-05-11T10:08:06",
            "minusPoints": 0
        },
        {
            "id_team": 39,
            "id_cypher": 5,
            "time": "2024-05-11T10:08:43",
            "minusPoints": 0
        },
        {
            "id_team": 9,
            "id_cypher": 4,
            "time": "2024-05-11T10:08:44",
            "minusPoints": 0
        },
        {
            "id_team": 10,
            "id_cypher": 6,
            "time": "2024-05-11T10:08:54",
            "minusPoints": 0
        },
        {
            "id_team": 50,
            "id_cypher": 3,
            "time": "2024-05-11T10:09:02",
            "minusPoints": 0
        },
        {
            "id_team": 21,
            "id_cypher": 3,
            "time": "2024-05-11T10:09:51",
            "minusPoints": 0
        },
        {
            "id_team": 15,
            "id_cypher": 3,
            "time": "2024-05-11T10:09:53",
            "minusPoints": 0
        },
        {
            "id_team": 41,
            "id_cypher": 4,
            "time": "2024-05-11T10:10:38",
            "minusPoints": 0
        },
        {
            "id_team": 6,
            "id_cypher": 5,
            "time": "2024-05-11T10:14:15",
            "minusPoints": 0
        },
        {
            "id_team": 24,
            "id_cypher": 5,
            "time": "2024-05-11T10:14:15",
            "minusPoints": 0
        },
        {
            "id_team": 49,
            "id_cypher": 4,
            "time": "2024-05-11T10:15:00",
            "minusPoints": 0
        },
        {
            "id_team": 42,
            "id_cypher": 4,
            "time": "2024-05-11T10:15:20",
            "minusPoints": 0
        },
        {
            "id_team": 17,
            "id_cypher": 4,
            "time": "2024-05-11T10:15:44",
            "minusPoints": 0
        },
        {
            "id_team": 5,
            "id_cypher": 3,
            "time": "2024-05-11T10:15:56",
            "minusPoints": 0
        },
        {
            "id_team": 35,
            "id_cypher": 4,
            "time": "2024-05-11T10:17:24",
            "minusPoints": 0
        },
        {
            "id_team": 56,
            "id_cypher": 6,
            "time": "2024-05-11T10:17:50",
            "minusPoints": 0
        },
        {
            "id_team": 10,
            "id_cypher": 7,
            "time": "2024-05-11T10:20:23",
            "minusPoints": 0
        },
        {
            "id_team": 34,
            "id_cypher": 3,
            "time": "2024-05-11T10:21:40",
            "minusPoints": 0
        },
        {
            "id_team": 21,
            "id_cypher": 4,
            "time": "2024-05-11T10:21:43",
            "minusPoints": 0
        },
        {
            "id_team": 53,
            "id_cypher": 4,
            "time": "2024-05-11T10:21:55",
            "minusPoints": 0
        },
        {
            "id_team": 7,
            "id_cypher": 5,
            "time": "2024-05-11T10:22:10",
            "minusPoints": 0
        },
        {
            "id_team": 19,
            "id_cypher": 4,
            "time": "2024-05-11T10:23:49",
            "minusPoints": 0
        },
        {
            "id_team": 36,
            "id_cypher": 3,
            "time": "2024-05-11T10:27:45",
            "minusPoints": 0
        },
        {
            "id_team": 42,
            "id_cypher": 5,
            "time": "2024-05-11T10:28:24",
            "minusPoints": 0
        },
        {
            "id_team": 32,
            "id_cypher": 5,
            "time": "2024-05-11T10:29:29",
            "minusPoints": 0
        },
        {
            "id_team": 10,
            "id_cypher": 8,
            "time": "2024-05-11T10:32:07",
            "minusPoints": 0
        },
        {
            "id_team": 34,
            "id_cypher": 4,
            "time": "2024-05-11T10:32:19",
            "minusPoints": 0
        },
        {
            "id_team": 40,
            "id_cypher": 6,
            "time": "2024-05-11T10:32:26",
            "minusPoints": 0
        },
        {
            "id_team": 21,
            "id_cypher": 5,
            "time": "2024-05-11T10:36:03",
            "minusPoints": 0
        },
        {
            "id_team": 50,
            "id_cypher": 5,
            "time": "2024-05-11T10:39:46",
            "minusPoints": 0
        },
        {
            "id_team": 54,
            "id_cypher": 5,
            "time": "2024-05-11T10:41:08",
            "minusPoints": 0
        },
        {
            "id_team": 58,
            "id_cypher": 8,
            "time": "2024-05-11T10:41:37",
            "minusPoints": 0
        },
        {
            "id_team": 26,
            "id_cypher": 5,
            "time": "2024-05-11T10:42:05",
            "minusPoints": 0
        },
        {
            "id_team": 33,
            "id_cypher": 4,
            "time": "2024-05-11T10:42:06",
            "minusPoints": 0
        },
        {
            "id_team": 52,
            "id_cypher": 6,
            "time": "2024-05-11T10:43:41",
            "minusPoints": 0
        },
        {
            "id_team": 19,
            "id_cypher": 5,
            "time": "2024-05-11T10:43:51",
            "minusPoints": 0
        },
        {
            "id_team": 9,
            "id_cypher": 6,
            "time": "2024-05-11T10:44:40",
            "minusPoints": 0
        },
        {
            "id_team": 34,
            "id_cypher": 5,
            "time": "2024-05-11T10:46:29",
            "minusPoints": 0
        },
        {
            "id_team": 40,
            "id_cypher": 7,
            "time": "2024-05-11T10:46:50",
            "minusPoints": 0
        },
        {
            "id_team": 6,
            "id_cypher": 6,
            "time": "2024-05-11T10:47:31",
            "minusPoints": 0
        },
        {
            "id_team": 30,
            "id_cypher": 6,
            "time": "2024-05-11T10:48:24",
            "minusPoints": 0
        },
        {
            "id_team": 5,
            "id_cypher": 5,
            "time": "2024-05-11T10:48:46",
            "minusPoints": 0
        },
        {
            "id_team": 24,
            "id_cypher": 6,
            "time": "2024-05-11T10:49:39",
            "minusPoints": 0
        },
        {
            "id_team": 16,
            "id_cypher": 7,
            "time": "2024-05-11T10:49:40",
            "minusPoints": 0
        },
        {
            "id_team": 23,
            "id_cypher": 9,
            "time": "2024-05-11T10:50:27",
            "minusPoints": 0
        },
        {
            "id_team": 21,
            "id_cypher": 6,
            "time": "2024-05-11T10:53:19",
            "minusPoints": 0
        },
        {
            "id_team": 2,
            "id_cypher": 6,
            "time": "2024-05-11T10:54:20",
            "minusPoints": 0
        },
        {
            "id_team": 51,
            "id_cypher": 6,
            "time": "2024-05-11T10:55:53",
            "minusPoints": 0
        },
        {
            "id_team": 28,
            "id_cypher": 6,
            "time": "2024-05-11T10:56:10",
            "minusPoints": 0
        },
        {
            "id_team": 41,
            "id_cypher": 6,
            "time": "2024-05-11T10:56:32",
            "minusPoints": 0
        },
        {
            "id_team": 42,
            "id_cypher": 6,
            "time": "2024-05-11T10:57:42",
            "minusPoints": 0
        },
        {
            "id_team": 31,
            "id_cypher": 7,
            "time": "2024-05-11T10:58:51",
            "minusPoints": 0
        },
        {
            "id_team": 32,
            "id_cypher": 6,
            "time": "2024-05-11T10:58:58",
            "minusPoints": 0
        },
        {
            "id_team": 53,
            "id_cypher": 6,
            "time": "2024-05-11T10:59:02",
            "minusPoints": 0
        },
        {
            "id_team": 38,
            "id_cypher": 5,
            "time": "2024-05-11T10:59:08",
            "minusPoints": 0
        },
        {
            "id_team": 1,
            "id_cypher": 6,
            "time": "2024-05-11T10:59:29",
            "minusPoints": 0
        },
        {
            "id_team": 11,
            "id_cypher": 7,
            "time": "2024-05-11T11:00:26",
            "minusPoints": 0
        },
        {
            "id_team": 6,
            "id_cypher": 7,
            "time": "2024-05-11T11:01:50",
            "minusPoints": 0
        },
        {
            "id_team": 57,
            "id_cypher": 5,
            "time": "2024-05-11T11:02:11",
            "minusPoints": 0
        },
        {
            "id_team": 35,
            "id_cypher": 6,
            "time": "2024-05-11T11:02:15",
            "minusPoints": 0
        },
        {
            "id_team": 33,
            "id_cypher": 5,
            "time": "2024-05-11T11:03:31",
            "minusPoints": 0
        },
        {
            "id_team": 9,
            "id_cypher": 7,
            "time": "2024-05-11T11:03:36",
            "minusPoints": 0
        },
        {
            "id_team": 37,
            "id_cypher": 5,
            "time": "2024-05-11T11:03:46",
            "minusPoints": 0
        },
        {
            "id_team": 15,
            "id_cypher": 7,
            "time": "2024-05-11T11:04:26",
            "minusPoints": 0
        },
        {
            "id_team": 2,
            "id_cypher": 7,
            "time": "2024-05-11T11:04:37",
            "minusPoints": 0
        },
        {
            "id_team": 7,
            "id_cypher": 6,
            "time": "2024-05-11T11:04:47",
            "minusPoints": 0
        },
        {
            "id_team": 50,
            "id_cypher": 6,
            "time": "2024-05-11T11:04:56",
            "minusPoints": 0
        },
        {
            "id_team": 22,
            "id_cypher": 7,
            "time": "2024-05-11T11:06:08",
            "minusPoints": 0
        },
        {
            "id_team": 18,
            "id_cypher": 6,
            "time": "2024-05-11T11:06:28",
            "minusPoints": 0
        },
        {
            "id_team": 26,
            "id_cypher": 6,
            "time": "2024-05-11T11:06:36",
            "minusPoints": 0
        },
        {
            "id_team": 52,
            "id_cypher": 7,
            "time": "2024-05-11T11:06:56",
            "minusPoints": 0
        },
        {
            "id_team": 51,
            "id_cypher": 7,
            "time": "2024-05-11T11:09:46",
            "minusPoints": 0
        },
        {
            "id_team": 41,
            "id_cypher": 7,
            "time": "2024-05-11T11:10:18",
            "minusPoints": 0
        },
        {
            "id_team": 19,
            "id_cypher": 6,
            "time": "2024-05-11T11:10:21",
            "minusPoints": 0
        },
        {
            "id_team": 39,
            "id_cypher": 7,
            "time": "2024-05-11T11:10:37",
            "minusPoints": 0
        },
        {
            "id_team": 11,
            "id_cypher": 8,
            "time": "2024-05-11T11:10:49",
            "minusPoints": 0
        },
        {
            "id_team": 27,
            "id_cypher": 6,
            "time": "2024-05-11T11:12:19",
            "minusPoints": 0
        },
        {
            "id_team": 17,
            "id_cypher": 6,
            "time": "2024-05-11T11:12:33",
            "minusPoints": 0
        },
        {
            "id_team": 24,
            "id_cypher": 7,
            "time": "2024-05-11T11:12:52",
            "minusPoints": 0
        },
        {
            "id_team": 11,
            "id_cypher": 9,
            "time": "2024-05-11T11:12:56",
            "minusPoints": 0
        },
        {
            "id_team": 42,
            "id_cypher": 7,
            "time": "2024-05-11T11:14:14",
            "minusPoints": 0
        },
        {
            "id_team": 29,
            "id_cypher": 6,
            "time": "2024-05-11T11:14:21",
            "minusPoints": 0
        },
        {
            "id_team": 34,
            "id_cypher": 6,
            "time": "2024-05-11T11:14:49",
            "minusPoints": 0
        },
        {
            "id_team": 28,
            "id_cypher": 7,
            "time": "2024-05-11T11:15:22",
            "minusPoints": 0
        },
        {
            "id_team": 54,
            "id_cypher": 6,
            "time": "2024-05-11T11:15:50",
            "minusPoints": 0
        },
        {
            "id_team": 35,
            "id_cypher": 7,
            "time": "2024-05-11T11:20:28",
            "minusPoints": 0
        },
        {
            "id_team": 50,
            "id_cypher": 7,
            "time": "2024-05-11T11:20:58",
            "minusPoints": 0
        },
        {
            "id_team": 7,
            "id_cypher": 7,
            "time": "2024-05-11T11:21:13",
            "minusPoints": 0
        },
        {
            "id_team": 52,
            "id_cypher": 8,
            "time": "2024-05-11T11:22:29",
            "minusPoints": 0
        },
        {
            "id_team": 18,
            "id_cypher": 7,
            "time": "2024-05-11T11:22:36",
            "minusPoints": 0
        },
        {
            "id_team": 26,
            "id_cypher": 7,
            "time": "2024-05-11T11:23:41",
            "minusPoints": 0
        },
        {
            "id_team": 36,
            "id_cypher": 5,
            "time": "2024-05-11T11:24:35",
            "minusPoints": 0
        },
        {
            "id_team": 6,
            "id_cypher": 9,
            "time": "2024-05-11T11:24:41",
            "minusPoints": 0
        },
        {
            "id_team": 19,
            "id_cypher": 7,
            "time": "2024-05-11T11:26:23",
            "minusPoints": 0
        },
        {
            "id_team": 53,
            "id_cypher": 7,
            "time": "2024-05-11T11:27:56",
            "minusPoints": 0
        },
        {
            "id_team": 38,
            "id_cypher": 6,
            "time": "2024-05-11T11:28:45",
            "minusPoints": 0
        },
        {
            "id_team": 42,
            "id_cypher": 8,
            "time": "2024-05-11T11:29:48",
            "minusPoints": 0
        },
        {
            "id_team": 17,
            "id_cypher": 7,
            "time": "2024-05-11T11:30:05",
            "minusPoints": 0
        },
        {
            "id_team": 57,
            "id_cypher": 6,
            "time": "2024-05-11T11:31:35",
            "minusPoints": 0
        },
        {
            "id_team": 41,
            "id_cypher": 8,
            "time": "2024-05-11T11:32:39",
            "minusPoints": 0
        },
        {
            "id_team": 42,
            "id_cypher": 9,
            "time": "2024-05-11T11:32:47",
            "minusPoints": 0
        },
        {
            "id_team": 1,
            "id_cypher": 8,
            "time": "2024-05-11T11:32:59",
            "minusPoints": 0
        },
        {
            "id_team": 1,
            "id_cypher": 9,
            "time": "2024-05-11T11:33:09",
            "minusPoints": 0
        },
        {
            "id_team": 13,
            "id_cypher": 6,
            "time": "2024-05-11T11:33:35",
            "minusPoints": 0
        },
        {
            "id_team": 55,
            "id_cypher": 8,
            "time": "2024-05-11T11:33:50",
            "minusPoints": 0
        },
        {
            "id_team": 26,
            "id_cypher": 8,
            "time": "2024-05-11T11:33:59",
            "minusPoints": 0
        },
        {
            "id_team": 41,
            "id_cypher": 9,
            "time": "2024-05-11T11:35:03",
            "minusPoints": 0
        },
        {
            "id_team": 26,
            "id_cypher": 9,
            "time": "2024-05-11T11:35:06",
            "minusPoints": 0
        },
        {
            "id_team": 59,
            "id_cypher": 6,
            "time": "2024-05-11T11:35:24",
            "minusPoints": 0
        },
        {
            "id_team": 35,
            "id_cypher": 9,
            "time": "2024-05-11T11:35:51",
            "minusPoints": 0
        },
        {
            "id_team": 29,
            "id_cypher": 7,
            "time": "2024-05-11T11:41:26",
            "minusPoints": 0
        },
        {
            "id_team": 55,
            "id_cypher": 9,
            "time": "2024-05-11T11:45:57",
            "minusPoints": 0
        },
        {
            "id_team": 56,
            "id_cypher": 11,
            "time": "2024-05-11T11:46:06",
            "minusPoints": 0
        },
        {
            "id_team": 5,
            "id_cypher": 6,
            "time": "2024-05-11T11:46:28",
            "minusPoints": 0
        },
        {
            "id_team": 37,
            "id_cypher": 6,
            "time": "2024-05-11T11:49:14",
            "minusPoints": 0
        },
        {
            "id_team": 29,
            "id_cypher": 8,
            "time": "2024-05-11T12:04:00",
            "minusPoints": 0
        },
        {
            "id_team": 13,
            "id_cypher": 8,
            "time": "2024-05-11T12:07:15",
            "minusPoints": 0
        },
        {
            "id_team": 21,
            "id_cypher": 8,
            "time": "2024-05-11T12:07:55",
            "minusPoints": 0
        },
        {
            "id_team": 33,
            "id_cypher": 7,
            "time": "2024-05-11T12:08:36",
            "minusPoints": 0
        },
        {
            "id_team": 20,
            "id_cypher": 8,
            "time": "2024-05-11T12:14:10",
            "minusPoints": 0
        },
        {
            "id_team": 54,
            "id_cypher": 8,
            "time": "2024-05-11T12:15:41",
            "minusPoints": 0
        },
        {
            "id_team": 59,
            "id_cypher": 8,
            "time": "2024-05-11T12:16:19",
            "minusPoints": 0
        },
        {
            "id_team": 38,
            "id_cypher": 9,
            "time": "2024-05-11T12:17:01",
            "minusPoints": 0
        },
        {
            "id_team": 28,
            "id_cypher": 8,
            "time": "2024-05-11T12:17:20",
            "minusPoints": 0
        },
        {
            "id_team": 18,
            "id_cypher": 8,
            "time": "2024-05-11T12:17:35",
            "minusPoints": 0
        },
        {
            "id_team": 39,
            "id_cypher": 8,
            "time": "2024-05-11T12:17:39",
            "minusPoints": 0
        },
        {
            "id_team": 51,
            "id_cypher": 8,
            "time": "2024-05-11T12:17:40",
            "minusPoints": 0
        },
        {
            "id_team": 59,
            "id_cypher": 9,
            "time": "2024-05-11T12:19:07",
            "minusPoints": 0
        },
        {
            "id_team": 54,
            "id_cypher": 9,
            "time": "2024-05-11T12:19:22",
            "minusPoints": 0
        },
        {
            "id_team": 24,
            "id_cypher": 8,
            "time": "2024-05-11T12:21:33",
            "minusPoints": 0
        },
        {
            "id_team": 33,
            "id_cypher": 8,
            "time": "2024-05-11T12:24:14",
            "minusPoints": 0
        },
        {
            "id_team": 2,
            "id_cypher": 8,
            "time": "2024-05-11T12:25:25",
            "minusPoints": 0
        },
        {
            "id_team": 37,
            "id_cypher": 7,
            "time": "2024-05-11T12:28:01",
            "minusPoints": 0
        },
        {
            "id_team": 33,
            "id_cypher": 9,
            "time": "2024-05-11T12:28:10",
            "minusPoints": 0
        },
        {
            "id_team": 16,
            "id_cypher": 9,
            "time": "2024-05-11T12:28:53",
            "minusPoints": 0
        },
        {
            "id_team": 22,
            "id_cypher": 8,
            "time": "2024-05-11T12:31:29",
            "minusPoints": 0
        },
        {
            "id_team": 39,
            "id_cypher": 9,
            "time": "2024-05-11T12:32:09",
            "minusPoints": 0
        },
        {
            "id_team": 36,
            "id_cypher": 7,
            "time": "2024-05-11T12:39:46",
            "minusPoints": 0
        },
        {
            "id_team": 28,
            "id_cypher": 11,
            "time": "2024-05-11T12:39:51",
            "minusPoints": 0
        },
        {
            "id_team": 16,
            "id_cypher": 10,
            "time": "2024-05-11T12:40:30",
            "minusPoints": 0
        },
        {
            "id_team": 2,
            "id_cypher": 9,
            "time": "2024-05-11T12:40:42",
            "minusPoints": 0
        },
        {
            "id_team": 39,
            "id_cypher": 11,
            "time": "2024-05-11T12:40:57",
            "minusPoints": 0
        },
        {
            "id_team": 40,
            "id_cypher": 10,
            "time": "2024-05-11T13:00:13",
            "minusPoints": 0
        },
        {
            "id_team": 40,
            "id_cypher": 11,
            "time": "2024-05-11T13:00:54",
            "minusPoints": 0
        },
        {
            "id_team": 24,
            "id_cypher": 10,
            "time": "2024-05-11T13:01:08",
            "minusPoints": 0
        },
        {
            "id_team": 18,
            "id_cypher": 10,
            "time": "2024-05-11T13:01:08",
            "minusPoints": 0
        },
        {
            "id_team": 18,
            "id_cypher": 11,
            "time": "2024-05-11T13:01:46",
            "minusPoints": 0
        },
        {
            "id_team": 24,
            "id_cypher": 11,
            "time": "2024-05-11T13:02:26",
            "minusPoints": 0
        },
        {
            "id_team": 22,
            "id_cypher": 10,
            "time": "2024-05-11T13:04:02",
            "minusPoints": 0
        },
        {
            "id_team": 36,
            "id_cypher": 8,
            "time": "2024-05-11T13:06:50",
            "minusPoints": 0
        },
        {
            "id_team": 34,
            "id_cypher": 9,
            "time": "2024-05-11T13:12:34",
            "minusPoints": 0
        },
        {
            "id_team": 5,
            "id_cypher": 8,
            "time": "2024-05-11T13:20:10",
            "minusPoints": 0
        },
        {
            "id_team": 25,
            "id_cypher": 9,
            "time": "2024-05-11T13:20:19",
            "minusPoints": 0
        },
        {
            "id_team": 25,
            "id_cypher": 10,
            "time": "2024-05-11T13:20:25",
            "minusPoints": 0
        },
        {
            "id_team": 10,
            "id_cypher": 1,
            "time": "2024-05-11T09:02:50",
            "minusPoints": 0
        },
        {
            "id_team": 5,
            "id_cypher": 1,
            "time": "2024-05-11T09:02:50",
            "minusPoints": 0
        },
        {
            "id_team": 29,
            "id_cypher": 1,
            "time": "2024-05-11T09:02:51",
            "minusPoints": 0
        },
        {
            "id_team": 18,
            "id_cypher": 1,
            "time": "2024-05-11T09:02:52",
            "minusPoints": 0
        },
        {
            "id_team": 55,
            "id_cypher": 1,
            "time": "2024-05-11T09:02:53",
            "minusPoints": 0
        },
        {
            "id_team": 33,
            "id_cypher": 1,
            "time": "2024-05-11T09:02:54",
            "minusPoints": 0
        },
        {
            "id_team": 24,
            "id_cypher": 1,
            "time": "2024-05-11T09:02:54",
            "minusPoints": 0
        },
        {
            "id_team": 1,
            "id_cypher": 1,
            "time": "2024-05-11T09:02:55",
            "minusPoints": 0
        },
        {
            "id_team": 21,
            "id_cypher": 1,
            "time": "2024-05-11T09:02:56",
            "minusPoints": 0
        },
        {
            "id_team": 16,
            "id_cypher": 1,
            "time": "2024-05-11T09:02:57",
            "minusPoints": 0
        },
        {
            "id_team": 40,
            "id_cypher": 1,
            "time": "2024-05-11T09:03:02",
            "minusPoints": 0
        },
        {
            "id_team": 4,
            "id_cypher": 1,
            "time": "2024-05-11T09:03:03",
            "minusPoints": 0
        },
        {
            "id_team": 37,
            "id_cypher": 1,
            "time": "2024-05-11T09:03:06",
            "minusPoints": 0
        },
        {
            "id_team": 42,
            "id_cypher": 1,
            "time": "2024-05-11T09:03:06",
            "minusPoints": 0
        },
        {
            "id_team": 22,
            "id_cypher": 1,
            "time": "2024-05-11T09:03:08",
            "minusPoints": 0
        },
        {
            "id_team": 32,
            "id_cypher": 1,
            "time": "2024-05-11T09:03:09",
            "minusPoints": 0
        },
        {
            "id_team": 19,
            "id_cypher": 1,
            "time": "2024-05-11T09:03:10",
            "minusPoints": 0
        },
        {
            "id_team": 41,
            "id_cypher": 1,
            "time": "2024-05-11T09:03:12",
            "minusPoints": 0
        },
        {
            "id_team": 11,
            "id_cypher": 1,
            "time": "2024-05-11T09:03:15",
            "minusPoints": 0
        },
        {
            "id_team": 7,
            "id_cypher": 1,
            "time": "2024-05-11T09:03:16",
            "minusPoints": 0
        },
        {
            "id_team": 9,
            "id_cypher": 1,
            "time": "2024-05-11T09:04:41",
            "minusPoints": 0
        },
        {
            "id_team": 38,
            "id_cypher": 1,
            "time": "2024-05-11T09:05:05",
            "minusPoints": 0
        },
        {
            "id_team": 52,
            "id_cypher": 1,
            "time": "2024-05-11T09:05:09",
            "minusPoints": 0
        },
        {
            "id_team": 40,
            "id_cypher": 2,
            "time": "2024-05-11T09:24:20",
            "minusPoints": 0
        },
        {
            "id_team": 56,
            "id_cypher": 2,
            "time": "2024-05-11T09:24:23",
            "minusPoints": 0
        },
        {
            "id_team": 10,
            "id_cypher": 2,
            "time": "2024-05-11T09:24:36",
            "minusPoints": 0
        },
        {
            "id_team": 6,
            "id_cypher": 1,
            "time": "2024-05-11T09:24:53",
            "minusPoints": 0
        },
        {
            "id_team": 39,
            "id_cypher": 2,
            "time": "2024-05-11T09:28:20",
            "minusPoints": 0
        },
        {
            "id_team": 1,
            "id_cypher": 2,
            "time": "2024-05-11T09:32:30",
            "minusPoints": 0
        },
        {
            "id_team": 55,
            "id_cypher": 3,
            "time": "2024-05-11T09:36:20",
            "minusPoints": 0
        },
        {
            "id_team": 32,
            "id_cypher": 2,
            "time": "2024-05-11T09:37:00",
            "minusPoints": 0
        },
        {
            "id_team": 6,
            "id_cypher": 2,
            "time": "2024-05-11T09:37:17",
            "minusPoints": 0
        },
        {
            "id_team": 7,
            "id_cypher": 2,
            "time": "2024-05-11T09:37:49",
            "minusPoints": 0
        },
        {
            "id_team": 52,
            "id_cypher": 2,
            "time": "2024-05-11T09:37:55",
            "minusPoints": 0
        },
        {
            "id_team": 24,
            "id_cypher": 2,
            "time": "2024-05-11T09:37:57",
            "minusPoints": 0
        },
        {
            "id_team": 30,
            "id_cypher": 2,
            "time": "2024-05-11T09:38:16",
            "minusPoints": 0
        },
        {
            "id_team": 20,
            "id_cypher": 3,
            "time": "2024-05-11T09:38:42",
            "minusPoints": 0
        },
        {
            "id_team": 29,
            "id_cypher": 2,
            "time": "2024-05-11T09:39:10",
            "minusPoints": 0
        },
        {
            "id_team": 23,
            "id_cypher": 3,
            "time": "2024-05-11T09:39:18",
            "minusPoints": 0
        },
        {
            "id_team": 9,
            "id_cypher": 2,
            "time": "2024-05-11T09:40:00",
            "minusPoints": 0
        },
        {
            "id_team": 58,
            "id_cypher": 3,
            "time": "2024-05-11T09:42:00",
            "minusPoints": 0
        },
        {
            "id_team": 11,
            "id_cypher": 3,
            "time": "2024-05-11T09:45:12",
            "minusPoints": 0
        },
        {
            "id_team": 53,
            "id_cypher": 1,
            "time": "2024-05-11T09:46:03",
            "minusPoints": 0
        },
        {
            "id_team": 17,
            "id_cypher": 1,
            "time": "2024-05-11T09:46:11",
            "minusPoints": 0
        },
        {
            "id_team": 1,
            "id_cypher": 3,
            "time": "2024-05-11T09:46:21",
            "minusPoints": 0
        },
        {
            "id_team": 49,
            "id_cypher": 2,
            "time": "2024-05-11T09:46:51",
            "minusPoints": 0
        },
        {
            "id_team": 41,
            "id_cypher": 2,
            "time": "2024-05-11T09:46:54",
            "minusPoints": 0
        },
        {
            "id_team": 56,
            "id_cypher": 4,
            "time": "2024-05-11T09:47:37",
            "minusPoints": 0
        },
        {
            "id_team": 19,
            "id_cypher": 2,
            "time": "2024-05-11T09:47:49",
            "minusPoints": 0
        },
        {
            "id_team": 35,
            "id_cypher": 2,
            "time": "2024-05-11T09:48:00",
            "minusPoints": 0
        },
        {
            "id_team": 55,
            "id_cypher": 4,
            "time": "2024-05-11T09:48:09",
            "minusPoints": 0
        },
        {
            "id_team": 38,
            "id_cypher": 2,
            "time": "2024-05-11T09:48:27",
            "minusPoints": 0
        },
        {
            "id_team": 50,
            "id_cypher": 2,
            "time": "2024-05-11T09:48:52",
            "minusPoints": 0
        },
        {
            "id_team": 6,
            "id_cypher": 3,
            "time": "2024-05-11T09:49:04",
            "minusPoints": 0
        },
        {
            "id_team": 16,
            "id_cypher": 3,
            "time": "2024-05-11T09:49:05",
            "minusPoints": 0
        },
        {
            "id_team": 54,
            "id_cypher": 2,
            "time": "2024-05-11T09:49:26",
            "minusPoints": 0
        },
        {
            "id_team": 24,
            "id_cypher": 3,
            "time": "2024-05-11T09:49:44",
            "minusPoints": 0
        },
        {
            "id_team": 23,
            "id_cypher": 4,
            "time": "2024-05-11T09:50:18",
            "minusPoints": 0
        },
        {
            "id_team": 20,
            "id_cypher": 4,
            "time": "2024-05-11T09:50:30",
            "minusPoints": 0
        },
        {
            "id_team": 10,
            "id_cypher": 5,
            "time": "2024-05-11T09:51:38",
            "minusPoints": 0
        },
        {
            "id_team": 52,
            "id_cypher": 3,
            "time": "2024-05-11T09:51:52",
            "minusPoints": 0
        },
        {
            "id_team": 7,
            "id_cypher": 3,
            "time": "2024-05-11T09:52:34",
            "minusPoints": 0
        },
        {
            "id_team": 39,
            "id_cypher": 4,
            "time": "2024-05-11T09:52:54",
            "minusPoints": 0
        },
        {
            "id_team": 59,
            "id_cypher": 2,
            "time": "2024-05-11T09:53:01",
            "minusPoints": 0
        },
        {
            "id_team": 51,
            "id_cypher": 4,
            "time": "2024-05-11T09:53:06",
            "minusPoints": 0
        },
        {
            "id_team": 28,
            "id_cypher": 4,
            "time": "2024-05-11T09:53:23",
            "minusPoints": 0
        },
        {
            "id_team": 5,
            "id_cypher": 2,
            "time": "2024-05-11T09:54:06",
            "minusPoints": 0
        },
        {
            "id_team": 21,
            "id_cypher": 2,
            "time": "2024-05-11T09:54:32",
            "minusPoints": 0
        },
        {
            "id_team": 41,
            "id_cypher": 3,
            "time": "2024-05-11T09:59:13",
            "minusPoints": 0
        },
        {
            "id_team": 17,
            "id_cypher": 3,
            "time": "2024-05-11T09:59:30",
            "minusPoints": 0
        },
        {
            "id_team": 24,
            "id_cypher": 4,
            "time": "2024-05-11T10:00:08",
            "minusPoints": 0
        },
        {
            "id_team": 6,
            "id_cypher": 4,
            "time": "2024-05-11T10:00:19",
            "minusPoints": 0
        },
        {
            "id_team": 20,
            "id_cypher": 5,
            "time": "2024-05-11T10:00:58",
            "minusPoints": 0
        },
        {
            "id_team": 16,
            "id_cypher": 4,
            "time": "2024-05-11T10:01:16",
            "minusPoints": 0
        },
        {
            "id_team": 55,
            "id_cypher": 5,
            "time": "2024-05-11T10:01:33",
            "minusPoints": 0
        },
        {
            "id_team": 37,
            "id_cypher": 2,
            "time": "2024-05-11T10:03:33",
            "minusPoints": 0
        },
        {
            "id_team": 52,
            "id_cypher": 4,
            "time": "2024-05-11T10:05:02",
            "minusPoints": 0
        },
        {
            "id_team": 36,
            "id_cypher": 1,
            "time": "2024-05-11T10:05:04",
            "minusPoints": 0
        },
        {
            "id_team": 36,
            "id_cypher": 2,
            "time": "2024-05-11T10:05:20",
            "minusPoints": 0
        },
        {
            "id_team": 7,
            "id_cypher": 4,
            "time": "2024-05-11T10:05:38",
            "minusPoints": 0
        },
        {
            "id_team": 54,
            "id_cypher": 3,
            "time": "2024-05-11T10:09:24",
            "minusPoints": 0
        },
        {
            "id_team": 27,
            "id_cypher": 4,
            "time": "2024-05-11T10:09:39",
            "minusPoints": 0
        },
        {
            "id_team": 38,
            "id_cypher": 3,
            "time": "2024-05-11T10:09:46",
            "minusPoints": 0
        },
        {
            "id_team": 33,
            "id_cypher": 2,
            "time": "2024-05-11T10:10:05",
            "minusPoints": 0
        },
        {
            "id_team": 53,
            "id_cypher": 3,
            "time": "2024-05-11T10:10:13",
            "minusPoints": 0
        },
        {
            "id_team": 59,
            "id_cypher": 3,
            "time": "2024-05-11T10:11:36",
            "minusPoints": 0
        },
        {
            "id_team": 18,
            "id_cypher": 4,
            "time": "2024-05-11T10:13:25",
            "minusPoints": 0
        },
        {
            "id_team": 32,
            "id_cypher": 4,
            "time": "2024-05-11T10:13:45",
            "minusPoints": 0
        },
        {
            "id_team": 25,
            "id_cypher": 3,
            "time": "2024-05-11T10:14:26",
            "minusPoints": 0
        },
        {
            "id_team": 19,
            "id_cypher": 3,
            "time": "2024-05-11T10:14:32",
            "minusPoints": 0
        },
        {
            "id_team": 25,
            "id_cypher": 4,
            "time": "2024-05-11T10:14:43",
            "minusPoints": 0
        },
        {
            "id_team": 29,
            "id_cypher": 4,
            "time": "2024-05-11T10:14:52",
            "minusPoints": 0
        },
        {
            "id_team": 13,
            "id_cypher": 3,
            "time": "2024-05-11T10:15:43",
            "minusPoints": 0
        },
        {
            "id_team": 2,
            "id_cypher": 4,
            "time": "2024-05-11T10:16:55",
            "minusPoints": 0
        },
        {
            "id_team": 16,
            "id_cypher": 5,
            "time": "2024-05-11T10:16:55",
            "minusPoints": 0
        },
        {
            "id_team": 1,
            "id_cypher": 5,
            "time": "2024-05-11T10:18:51",
            "minusPoints": 0
        },
        {
            "id_team": 54,
            "id_cypher": 4,
            "time": "2024-05-11T10:20:34",
            "minusPoints": 0
        },
        {
            "id_team": 52,
            "id_cypher": 5,
            "time": "2024-05-11T10:21:11",
            "minusPoints": 0
        },
        {
            "id_team": 58,
            "id_cypher": 6,
            "time": "2024-05-11T10:22:13",
            "minusPoints": 0
        },
        {
            "id_team": 4,
            "id_cypher": 6,
            "time": "2024-05-11T10:23:46",
            "minusPoints": 0
        },
        {
            "id_team": 50,
            "id_cypher": 4,
            "time": "2024-05-11T10:24:48",
            "minusPoints": 0
        },
        {
            "id_team": 22,
            "id_cypher": 5,
            "time": "2024-05-11T10:25:01",
            "minusPoints": 0
        },
        {
            "id_team": 13,
            "id_cypher": 4,
            "time": "2024-05-11T10:25:28",
            "minusPoints": 0
        },
        {
            "id_team": 41,
            "id_cypher": 5,
            "time": "2024-05-11T10:26:38",
            "minusPoints": 0
        },
        {
            "id_team": 31,
            "id_cypher": 5,
            "time": "2024-05-11T10:27:13",
            "minusPoints": 0
        },
        {
            "id_team": 37,
            "id_cypher": 3,
            "time": "2024-05-11T10:27:22",
            "minusPoints": 0
        },
        {
            "id_team": 55,
            "id_cypher": 6,
            "time": "2024-05-11T10:27:24",
            "minusPoints": 0
        },
        {
            "id_team": 20,
            "id_cypher": 6,
            "time": "2024-05-11T10:29:30",
            "minusPoints": 0
        },
        {
            "id_team": 27,
            "id_cypher": 5,
            "time": "2024-05-11T10:29:47",
            "minusPoints": 0
        },
        {
            "id_team": 18,
            "id_cypher": 5,
            "time": "2024-05-11T10:30:01",
            "minusPoints": 0
        },
        {
            "id_team": 5,
            "id_cypher": 4,
            "time": "2024-05-11T10:30:42",
            "minusPoints": 0
        },
        {
            "id_team": 2,
            "id_cypher": 5,
            "time": "2024-05-11T10:32:03",
            "minusPoints": 0
        },
        {
            "id_team": 56,
            "id_cypher": 7,
            "time": "2024-05-11T10:32:36",
            "minusPoints": 0
        },
        {
            "id_team": 59,
            "id_cypher": 4,
            "time": "2024-05-11T10:32:45",
            "minusPoints": 0
        },
        {
            "id_team": 53,
            "id_cypher": 5,
            "time": "2024-05-11T10:34:02",
            "minusPoints": 0
        },
        {
            "id_team": 17,
            "id_cypher": 5,
            "time": "2024-05-11T10:34:12",
            "minusPoints": 0
        },
        {
            "id_team": 10,
            "id_cypher": 9,
            "time": "2024-05-11T10:34:37",
            "minusPoints": 0
        },
        {
            "id_team": 38,
            "id_cypher": 4,
            "time": "2024-05-11T10:34:37",
            "minusPoints": 0
        },
        {
            "id_team": 4,
            "id_cypher": 7,
            "time": "2024-05-11T10:35:02",
            "minusPoints": 0
        },
        {
            "id_team": 9,
            "id_cypher": 8,
            "time": "2024-05-11T11:15:25",
            "minusPoints": 0
        },
        {
            "id_team": 1,
            "id_cypher": 7,
            "time": "2024-05-11T11:15:43",
            "minusPoints": 0
        },
        {
            "id_team": 25,
            "id_cypher": 7,
            "time": "2024-05-11T11:16:07",
            "minusPoints": 0
        },
        {
            "id_team": 56,
            "id_cypher": 8,
            "time": "2024-05-11T11:16:26",
            "minusPoints": 0
        },
        {
            "id_team": 49,
            "id_cypher": 6,
            "time": "2024-05-11T11:16:27",
            "minusPoints": 0
        },
        {
            "id_team": 21,
            "id_cypher": 7,
            "time": "2024-05-11T11:17:57",
            "minusPoints": 0
        },
        {
            "id_team": 9,
            "id_cypher": 9,
            "time": "2024-05-11T11:19:07",
            "minusPoints": 0
        },
        {
            "id_team": 6,
            "id_cypher": 8,
            "time": "2024-05-11T11:21:25",
            "minusPoints": 0
        },
        {
            "id_team": 52,
            "id_cypher": 9,
            "time": "2024-05-11T11:22:37",
            "minusPoints": 0
        },
        {
            "id_team": 35,
            "id_cypher": 8,
            "time": "2024-05-11T11:33:59",
            "minusPoints": 0
        },
        {
            "id_team": 7,
            "id_cypher": 8,
            "time": "2024-05-11T11:34:38",
            "minusPoints": 0
        },
        {
            "id_team": 50,
            "id_cypher": 8,
            "time": "2024-05-11T11:36:11",
            "minusPoints": 0
        },
        {
            "id_team": 49,
            "id_cypher": 7,
            "time": "2024-05-11T11:36:58",
            "minusPoints": 0
        },
        {
            "id_team": 27,
            "id_cypher": 7,
            "time": "2024-05-11T11:37:57",
            "minusPoints": 0
        },
        {
            "id_team": 56,
            "id_cypher": 9,
            "time": "2024-05-11T11:38:06",
            "minusPoints": 0
        },
        {
            "id_team": 50,
            "id_cypher": 9,
            "time": "2024-05-11T11:38:08",
            "minusPoints": 0
        },
        {
            "id_team": 7,
            "id_cypher": 9,
            "time": "2024-05-11T11:38:32",
            "minusPoints": 0
        },
        {
            "id_team": 54,
            "id_cypher": 7,
            "time": "2024-05-11T11:42:34",
            "minusPoints": 0
        },
        {
            "id_team": 32,
            "id_cypher": 7,
            "time": "2024-05-11T11:42:50",
            "minusPoints": 0
        },
        {
            "id_team": 56,
            "id_cypher": 10,
            "time": "2024-05-11T11:44:29",
            "minusPoints": 0
        },
        {
            "id_team": 57,
            "id_cypher": 7,
            "time": "2024-05-11T11:49:59",
            "minusPoints": 0
        },
        {
            "id_team": 34,
            "id_cypher": 7,
            "time": "2024-05-11T11:50:17",
            "minusPoints": 0
        },
        {
            "id_team": 33,
            "id_cypher": 6,
            "time": "2024-05-11T11:51:40",
            "minusPoints": 0
        },
        {
            "id_team": 49,
            "id_cypher": 8,
            "time": "2024-05-11T11:52:55",
            "minusPoints": 0
        },
        {
            "id_team": 49,
            "id_cypher": 9,
            "time": "2024-05-11T11:53:07",
            "minusPoints": 0
        },
        {
            "id_team": 27,
            "id_cypher": 8,
            "time": "2024-05-11T11:53:39",
            "minusPoints": 0
        },
        {
            "id_team": 55,
            "id_cypher": 10,
            "time": "2024-05-11T11:54:33",
            "minusPoints": 0
        },
        {
            "id_team": 55,
            "id_cypher": 11,
            "time": "2024-05-11T11:56:16",
            "minusPoints": 0
        },
        {
            "id_team": 27,
            "id_cypher": 9,
            "time": "2024-05-11T11:57:18",
            "minusPoints": 0
        },
        {
            "id_team": 59,
            "id_cypher": 7,
            "time": "2024-05-11T11:57:27",
            "minusPoints": 0
        },
        {
            "id_team": 16,
            "id_cypher": 8,
            "time": "2024-05-11T11:58:04",
            "minusPoints": 0
        },
        {
            "id_team": 38,
            "id_cypher": 7,
            "time": "2024-05-11T11:58:37",
            "minusPoints": 0
        },
        {
            "id_team": 19,
            "id_cypher": 8,
            "time": "2024-05-11T11:59:42",
            "minusPoints": 0
        },
        {
            "id_team": 29,
            "id_cypher": 9,
            "time": "2024-05-11T12:04:08",
            "minusPoints": 0
        },
        {
            "id_team": 57,
            "id_cypher": 8,
            "time": "2024-05-11T12:10:58",
            "minusPoints": 0
        },
        {
            "id_team": 13,
            "id_cypher": 9,
            "time": "2024-05-11T12:11:49",
            "minusPoints": 0
        },
        {
            "id_team": 57,
            "id_cypher": 9,
            "time": "2024-05-11T12:13:52",
            "minusPoints": 0
        },
        {
            "id_team": 38,
            "id_cypher": 8,
            "time": "2024-05-11T12:14:41",
            "minusPoints": 0
        },
        {
            "id_team": 40,
            "id_cypher": 8,
            "time": "2024-05-11T12:16:19",
            "minusPoints": 0
        },
        {
            "id_team": 53,
            "id_cypher": 8,
            "time": "2024-05-11T12:20:36",
            "minusPoints": 0
        },
        {
            "id_team": 19,
            "id_cypher": 9,
            "time": "2024-05-11T12:25:52",
            "minusPoints": 0
        },
        {
            "id_team": 30,
            "id_cypher": 7,
            "time": "2024-05-11T12:26:40",
            "minusPoints": 0
        },
        {
            "id_team": 4,
            "id_cypher": 9,
            "time": "2024-05-11T12:26:53",
            "minusPoints": 0
        },
        {
            "id_team": 5,
            "id_cypher": 7,
            "time": "2024-05-11T12:27:41",
            "minusPoints": 0
        },
        {
            "id_team": 20,
            "id_cypher": 9,
            "time": "2024-05-11T12:27:47",
            "minusPoints": 0
        },
        {
            "id_team": 31,
            "id_cypher": 8,
            "time": "2024-05-11T12:31:27",
            "minusPoints": 0
        },
        {
            "id_team": 28,
            "id_cypher": 9,
            "time": "2024-05-11T12:32:11",
            "minusPoints": 0
        },
        {
            "id_team": 51,
            "id_cypher": 9,
            "time": "2024-05-11T12:32:26",
            "minusPoints": 0
        },
        {
            "id_team": 4,
            "id_cypher": 11,
            "time": "2024-05-11T12:36:09",
            "minusPoints": 0
        },
        {
            "id_team": 24,
            "id_cypher": 9,
            "time": "2024-05-11T12:37:44",
            "minusPoints": 0
        },
        {
            "id_team": 28,
            "id_cypher": 10,
            "time": "2024-05-11T12:38:11",
            "minusPoints": 0
        },
        {
            "id_team": 36,
            "id_cypher": 6,
            "time": "2024-05-11T12:39:38",
            "minusPoints": 0
        },
        {
            "id_team": 53,
            "id_cypher": 10,
            "time": "2024-05-11T12:44:10",
            "minusPoints": 0
        },
        {
            "id_team": 20,
            "id_cypher": 10,
            "time": "2024-05-11T12:44:27",
            "minusPoints": 0
        },
        {
            "id_team": 20,
            "id_cypher": 11,
            "time": "2024-05-11T12:47:11",
            "minusPoints": 0
        },
        {
            "id_team": 25,
            "id_cypher": 8,
            "time": "2024-05-11T12:48:06",
            "minusPoints": 0
        },
        {
            "id_team": 40,
            "id_cypher": 9,
            "time": "2024-05-11T12:48:11",
            "minusPoints": 0
        },
        {
            "id_team": 18,
            "id_cypher": 9,
            "time": "2024-05-11T12:49:04",
            "minusPoints": 0
        },
        {
            "id_team": 2,
            "id_cypher": 10,
            "time": "2024-05-11T12:49:43",
            "minusPoints": 0
        },
        {
            "id_team": 17,
            "id_cypher": 8,
            "time": "2024-05-11T12:50:26",
            "minusPoints": 0
        },
        {
            "id_team": 21,
            "id_cypher": 10,
            "time": "2024-05-11T12:50:38",
            "minusPoints": 0
        },
        {
            "id_team": 2,
            "id_cypher": 11,
            "time": "2024-05-11T12:50:43",
            "minusPoints": 0
        },
        {
            "id_team": 31,
            "id_cypher": 10,
            "time": "2024-05-11T12:52:24",
            "minusPoints": 0
        },
        {
            "id_team": 31,
            "id_cypher": 11,
            "time": "2024-05-11T12:53:55",
            "minusPoints": 0
        },
        {
            "id_team": 22,
            "id_cypher": 11,
            "time": "2024-05-11T13:06:25",
            "minusPoints": 0
        },
        {
            "id_team": 36,
            "id_cypher": 9,
            "time": "2024-05-11T13:07:06",
            "minusPoints": 0
        },
        {
            "id_team": 32,
            "id_cypher": 9,
            "time": "2024-05-11T13:07:17",
            "minusPoints": 0
        },
        {
            "id_team": 17,
            "id_cypher": 9,
            "time": "2024-05-11T13:15:23",
            "minusPoints": 0
        },
        {
            "id_team": 15,
            "id_cypher": 8,
            "time": "2024-05-11T13:19:35",
            "minusPoints": 0
        },
        {
            "id_team": 25,
            "id_cypher": 11,
            "time": "2024-05-11T13:20:36",
            "minusPoints": 0
        },
        {
            "id_team": 37,
            "id_cypher": 8,
            "time": "2024-05-11T13:22:00",
            "minusPoints": 0
        },
        {
            "id_team": 34,
            "id_cypher": 10,
            "time": "2024-05-11T13:24:25",
            "minusPoints": 0
        },
        {
            "id_team": 34,
            "id_cypher": 11,
            "time": "2024-05-11T13:26:35",
            "minusPoints": 0
        },
        {
            "id_team": 15,
            "id_cypher": 9,
            "time": "2024-05-11T13:33:25",
            "minusPoints": 0
        },
        {
            "id_team": 17,
            "id_cypher": 10,
            "time": "2024-05-11T13:35:19",
            "minusPoints": 0
        },
        {
            "id_team": 17,
            "id_cypher": 11,
            "time": "2024-05-11T13:35:24",
            "minusPoints": 0
        },
        {
            "id_team": 32,
            "id_cypher": 10,
            "time": "2024-05-11T13:37:13",
            "minusPoints": 0
        },
        {
            "id_team": 32,
            "id_cypher": 11,
            "time": "2024-05-11T13:38:38",
            "minusPoints": 0
        },
        {
            "id_team": 15,
            "id_cypher": 10,
            "time": "2024-05-11T13:43:05",
            "minusPoints": 0
        },
        {
            "id_team": 15,
            "id_cypher": 11,
            "time": "2024-05-11T13:43:23",
            "minusPoints": 0
        },
        {
            "id_team": 5,
            "id_cypher": 9,
            "time": "2024-05-11T13:45:31",
            "minusPoints": 0
        },
        {
            "id_team": 59,
            "id_cypher": 1,
            "time": "2024-05-11T09:03:27",
            "minusPoints": 0
        },
        {
            "id_team": 34,
            "id_cypher": 1,
            "time": "2024-05-11T09:03:29",
            "minusPoints": 0
        },
        {
            "id_team": 57,
            "id_cypher": 1,
            "time": "2024-05-11T09:03:42",
            "minusPoints": 0
        },
        {
            "id_team": 31,
            "id_cypher": 1,
            "time": "2024-05-11T09:03:45",
            "minusPoints": 0
        },
        {
            "id_team": 35,
            "id_cypher": 1,
            "time": "2024-05-11T09:03:49",
            "minusPoints": 0
        },
        {
            "id_team": 30,
            "id_cypher": 1,
            "time": "2024-05-11T09:03:59",
            "minusPoints": 0
        },
        {
            "id_team": 23,
            "id_cypher": 1,
            "time": "2024-05-11T09:04:03",
            "minusPoints": 0
        },
        {
            "id_team": 13,
            "id_cypher": 1,
            "time": "2024-05-11T09:04:10",
            "minusPoints": 0
        },
        {
            "id_team": 26,
            "id_cypher": 4,
            "time": "2024-05-11T10:19:23",
            "minusPoints": 0
        },
        {
            "id_team": 15,
            "id_cypher": 4,
            "time": "2024-05-11T10:19:48",
            "minusPoints": 0
        },
        {
            "id_team": 11,
            "id_cypher": 5,
            "time": "2024-05-11T10:19:59",
            "minusPoints": 0
        },
        {
            "id_team": 9,
            "id_cypher": 5,
            "time": "2024-05-11T10:24:14",
            "minusPoints": 0
        },
        {
            "id_team": 23,
            "id_cypher": 6,
            "time": "2024-05-11T10:24:30",
            "minusPoints": 0
        },
        {
            "id_team": 57,
            "id_cypher": 3,
            "time": "2024-05-11T10:25:41",
            "minusPoints": 0
        },
        {
            "id_team": 30,
            "id_cypher": 5,
            "time": "2024-05-11T10:25:42",
            "minusPoints": 0
        },
        {
            "id_team": 33,
            "id_cypher": 3,
            "time": "2024-05-11T10:27:38",
            "minusPoints": 0
        },
        {
            "id_team": 15,
            "id_cypher": 5,
            "time": "2024-05-11T10:33:58",
            "minusPoints": 0
        },
        {
            "id_team": 58,
            "id_cypher": 7,
            "time": "2024-05-11T10:34:33",
            "minusPoints": 0
        },
        {
            "id_team": 35,
            "id_cypher": 5,
            "time": "2024-05-11T10:35:50",
            "minusPoints": 0
        },
        {
            "id_team": 16,
            "id_cypher": 6,
            "time": "2024-05-11T10:37:41",
            "minusPoints": 0
        },
        {
            "id_team": 29,
            "id_cypher": 5,
            "time": "2024-05-11T10:38:32",
            "minusPoints": 0
        },
        {
            "id_team": 25,
            "id_cypher": 5,
            "time": "2024-05-11T10:38:48",
            "minusPoints": 0
        },
        {
            "id_team": 57,
            "id_cypher": 4,
            "time": "2024-05-11T10:39:10",
            "minusPoints": 0
        },
        {
            "id_team": 55,
            "id_cypher": 7,
            "time": "2024-05-11T10:39:16",
            "minusPoints": 0
        },
        {
            "id_team": 23,
            "id_cypher": 7,
            "time": "2024-05-11T10:41:09",
            "minusPoints": 0
        },
        {
            "id_team": 49,
            "id_cypher": 5,
            "time": "2024-05-11T10:42:17",
            "minusPoints": 0
        },
        {
            "id_team": 58,
            "id_cypher": 9,
            "time": "2024-05-11T10:42:58",
            "minusPoints": 0
        },
        {
            "id_team": 37,
            "id_cypher": 4,
            "time": "2024-05-11T10:43:05",
            "minusPoints": 0
        },
        {
            "id_team": 11,
            "id_cypher": 6,
            "time": "2024-05-11T10:43:41",
            "minusPoints": 0
        },
        {
            "id_team": 36,
            "id_cypher": 4,
            "time": "2024-05-11T10:47:14",
            "minusPoints": 0
        },
        {
            "id_team": 23,
            "id_cypher": 8,
            "time": "2024-05-11T10:48:34",
            "minusPoints": 0
        },
        {
            "id_team": 31,
            "id_cypher": 6,
            "time": "2024-05-11T10:49:12",
            "minusPoints": 0
        },
        {
            "id_team": 20,
            "id_cypher": 7,
            "time": "2024-05-11T10:50:40",
            "minusPoints": 0
        },
        {
            "id_team": 22,
            "id_cypher": 6,
            "time": "2024-05-11T10:50:54",
            "minusPoints": 0
        },
        {
            "id_team": 13,
            "id_cypher": 5,
            "time": "2024-05-11T10:53:08",
            "minusPoints": 0
        },
        {
            "id_team": 25,
            "id_cypher": 6,
            "time": "2024-05-11T10:53:56",
            "minusPoints": 0
        },
        {
            "id_team": 15,
            "id_cypher": 6,
            "time": "2024-05-11T10:54:10",
            "minusPoints": 0
        },
        {
            "id_team": 39,
            "id_cypher": 6,
            "time": "2024-05-11T10:55:13",
            "minusPoints": 0
        },
        {
            "id_team": 59,
            "id_cypher": 5,
            "time": "2024-05-11T10:55:26",
            "minusPoints": 0
        },
        {
            "id_team": 13,
            "id_cypher": 7,
            "time": "2024-05-11T11:55:18",
            "minusPoints": 0
        },
        {
            "id_team": 4,
            "id_cypher": 8,
            "time": "2024-05-11T12:05:14",
            "minusPoints": 0
        },
        {
            "id_team": 53,
            "id_cypher": 9,
            "time": "2024-05-11T12:33:44",
            "minusPoints": 0
        },
        {
            "id_team": 4,
            "id_cypher": 10,
            "time": "2024-05-11T12:34:18",
            "minusPoints": 0
        },
        {
            "id_team": 30,
            "id_cypher": 8,
            "time": "2024-05-11T12:35:35",
            "minusPoints": 0
        },
        {
            "id_team": 30,
            "id_cypher": 9,
            "time": "2024-05-11T12:35:47",
            "minusPoints": 0
        },
        {
            "id_team": 51,
            "id_cypher": 10,
            "time": "2024-05-11T12:38:16",
            "minusPoints": 0
        },
        {
            "id_team": 21,
            "id_cypher": 9,
            "time": "2024-05-11T12:38:22",
            "minusPoints": 0
        },
        {
            "id_team": 39,
            "id_cypher": 10,
            "time": "2024-05-11T12:38:46",
            "minusPoints": 0
        },
        {
            "id_team": 51,
            "id_cypher": 11,
            "time": "2024-05-11T12:40:58",
            "minusPoints": 0
        },
        {
            "id_team": 16,
            "id_cypher": 11,
            "time": "2024-05-11T12:41:34",
            "minusPoints": 0
        },
        {
            "id_team": 32,
            "id_cypher": 8,
            "time": "2024-05-11T12:44:28",
            "minusPoints": 0
        },
        {
            "id_team": 31,
            "id_cypher": 9,
            "time": "2024-05-11T12:46:14",
            "minusPoints": 0
        },
        {
            "id_team": 53,
            "id_cypher": 11,
            "time": "2024-05-11T12:46:41",
            "minusPoints": 0
        },
        {
            "id_team": 21,
            "id_cypher": 11,
            "time": "2024-05-11T12:51:59",
            "minusPoints": 0
        },
        {
            "id_team": 34,
            "id_cypher": 8,
            "time": "2024-05-11T12:54:44",
            "minusPoints": 0
        },
        {
            "id_team": 22,
            "id_cypher": 9,
            "time": "2024-05-11T12:54:47",
            "minusPoints": 0
        },
        {
            "id_team": 5,
            "id_cypher": 11,
            "time": "2024-05-11T13:59:35",
            "minusPoints": 0
        },
        {
            "id_team": 5,
            "id_cypher": 10,
            "time": "2024-05-11T13:58:47",
            "minusPoints": 0
        }
    ],
    "teamHelps": [
        {
            "id_team": 36,
            "help": {
                "Id": 97,
                "cypher": 2,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T10:05:38"
            }
        },
        {
            "id_team": 37,
            "help": {
                "Id": 127,
                "cypher": 5,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T11:16:48"
            }
        },
        {
            "id_team": 36,
            "help": {
                "Id": 106,
                "cypher": 5,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T11:24:51"
            }
        },
        {
            "id_team": 32,
            "help": {
                "Id": 130,
                "cypher": 6,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T11:26:13"
            }
        },
        {
            "id_team": 36,
            "help": {
                "Id": 107,
                "cypher": 5,
                "order": 2,
                "points": 15,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T11:30:59"
            }
        },
        {
            "id_team": 33,
            "help": {
                "Id": 106,
                "cypher": 5,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T11:33:52"
            }
        },
        {
            "id_team": 16,
            "help": {
                "Id": 134,
                "cypher": 7,
                "order": 2,
                "points": 30,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T11:37:13"
            }
        },
        {
            "id_team": 21,
            "help": {
                "Id": 133,
                "cypher": 7,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T11:42:20"
            }
        },
        {
            "id_team": 4,
            "help": {
                "Id": 134,
                "cypher": 7,
                "order": 2,
                "points": 30,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T11:45:18"
            }
        },
        {
            "id_team": 39,
            "help": {
                "Id": 133,
                "cypher": 7,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T11:45:37"
            }
        },
        {
            "id_team": 24,
            "help": {
                "Id": 133,
                "cypher": 7,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T11:45:54"
            }
        },
        {
            "id_team": 20,
            "help": {
                "Id": 133,
                "cypher": 7,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T11:46:40"
            }
        },
        {
            "id_team": 25,
            "help": {
                "Id": 133,
                "cypher": 7,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T11:46:54"
            }
        },
        {
            "id_team": 21,
            "help": {
                "Id": 134,
                "cypher": 7,
                "order": 2,
                "points": 30,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T11:49:38"
            }
        },
        {
            "id_team": 18,
            "help": {
                "Id": 133,
                "cypher": 7,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T11:49:43"
            }
        },
        {
            "id_team": 22,
            "help": {
                "Id": 133,
                "cypher": 7,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T11:52:20"
            }
        },
        {
            "id_team": 40,
            "help": {
                "Id": 134,
                "cypher": 7,
                "order": 2,
                "points": 30,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T11:53:58"
            }
        },
        {
            "id_team": 53,
            "help": {
                "Id": 133,
                "cypher": 7,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T11:54:19"
            }
        },
        {
            "id_team": 39,
            "help": {
                "Id": 134,
                "cypher": 7,
                "order": 2,
                "points": 30,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T11:54:37"
            }
        },
        {
            "id_team": 31,
            "help": {
                "Id": 133,
                "cypher": 7,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T11:57:05"
            }
        },
        {
            "id_team": 24,
            "help": {
                "Id": 134,
                "cypher": 7,
                "order": 2,
                "points": 30,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T11:59:37"
            }
        },
        {
            "id_team": 37,
            "help": {
                "Id": 130,
                "cypher": 6,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T11:59:45"
            }
        },
        {
            "id_team": 2,
            "help": {
                "Id": 134,
                "cypher": 7,
                "order": 2,
                "points": 30,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T12:01:02"
            }
        },
        {
            "id_team": 53,
            "help": {
                "Id": 134,
                "cypher": 7,
                "order": 2,
                "points": 30,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T12:01:38"
            }
        },
        {
            "id_team": 5,
            "help": {
                "Id": 130,
                "cypher": 6,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T12:02:40"
            }
        },
        {
            "id_team": 54,
            "help": {
                "Id": 112,
                "cypher": 7,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T12:08:33"
            }
        },
        {
            "id_team": 32,
            "help": {
                "Id": 133,
                "cypher": 7,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T12:10:57"
            }
        },
        {
            "id_team": 17,
            "help": {
                "Id": 133,
                "cypher": 7,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T12:12:20"
            }
        },
        {
            "id_team": 17,
            "help": {
                "Id": 134,
                "cypher": 7,
                "order": 2,
                "points": 30,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T12:17:46"
            }
        },
        {
            "id_team": 37,
            "help": {
                "Id": 131,
                "cypher": 6,
                "order": 2,
                "points": 30,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T12:18:31"
            }
        },
        {
            "id_team": 37,
            "help": {
                "Id": 132,
                "cypher": 6,
                "order": 3,
                "points": -60,
                "type": "A",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T12:18:46"
            }
        },
        {
            "id_team": 32,
            "help": {
                "Id": 134,
                "cypher": 7,
                "order": 2,
                "points": 30,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T12:18:56"
            }
        },
        {
            "id_team": 34,
            "help": {
                "Id": 133,
                "cypher": 7,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T12:19:26"
            }
        },
        {
            "id_team": 34,
            "help": {
                "Id": 134,
                "cypher": 7,
                "order": 2,
                "points": 30,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T12:23:50"
            }
        },
        {
            "id_team": 37,
            "help": {
                "Id": 133,
                "cypher": 7,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T12:42:08"
            }
        },
        {
            "id_team": 15,
            "help": {
                "Id": 134,
                "cypher": 7,
                "order": 2,
                "points": 30,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T13:07:05"
            }
        },
        {
            "id_team": 37,
            "help": {
                "Id": 136,
                "cypher": 8,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T13:27:36"
            }
        },
        {
            "id_team": 24,
            "help": {
                "Id": 127,
                "cypher": 5,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T10:36:16"
            }
        },
        {
            "id_team": 1,
            "help": {
                "Id": 106,
                "cypher": 5,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T10:43:12"
            }
        },
        {
            "id_team": 1,
            "help": {
                "Id": 107,
                "cypher": 5,
                "order": 2,
                "points": 15,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T10:43:25"
            }
        },
        {
            "id_team": 4,
            "help": {
                "Id": 133,
                "cypher": 7,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T11:12:34"
            }
        },
        {
            "id_team": 2,
            "help": {
                "Id": 133,
                "cypher": 7,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T11:27:46"
            }
        },
        {
            "id_team": 16,
            "help": {
                "Id": 133,
                "cypher": 7,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T11:28:22"
            }
        },
        {
            "id_team": 40,
            "help": {
                "Id": 133,
                "cypher": 7,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T11:33:19"
            }
        },
        {
            "id_team": 18,
            "help": {
                "Id": 134,
                "cypher": 7,
                "order": 2,
                "points": 30,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T11:55:31"
            }
        },
        {
            "id_team": 25,
            "help": {
                "Id": 134,
                "cypher": 7,
                "order": 2,
                "points": 30,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T12:05:49"
            }
        },
        {
            "id_team": 37,
            "help": {
                "Id": 134,
                "cypher": 7,
                "order": 2,
                "points": 30,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T12:44:31"
            }
        },
        {
            "id_team": 36,
            "help": {
                "Id": 112,
                "cypher": 7,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T12:46:48"
            }
        },
        {
            "id_team": 39,
            "help": {
                "Id": 127,
                "cypher": 5,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T10:43:44"
            }
        },
        {
            "id_team": 39,
            "help": {
                "Id": 128,
                "cypher": 5,
                "order": 2,
                "points": 30,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T10:44:05"
            }
        },
        {
            "id_team": 7,
            "help": {
                "Id": 106,
                "cypher": 5,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T10:46:38"
            }
        },
        {
            "id_team": 36,
            "help": {
                "Id": 103,
                "cypher": 4,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T10:47:39"
            }
        },
        {
            "id_team": 27,
            "help": {
                "Id": 106,
                "cypher": 5,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T10:57:04"
            }
        },
        {
            "id_team": 27,
            "help": {
                "Id": 107,
                "cypher": 5,
                "order": 2,
                "points": 15,
                "type": "I",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T10:57:19"
            }
        },
        {
            "id_team": 53,
            "help": {
                "Id": 130,
                "cypher": 6,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T11:07:20"
            }
        },
        {
            "id_team": 57,
            "help": {
                "Id": 106,
                "cypher": 5,
                "order": 1,
                "points": 15,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T11:07:52"
            }
        },
        {
            "id_team": 15,
            "help": {
                "Id": 133,
                "cypher": 7,
                "order": 1,
                "points": 30,
                "type": "N",
                "help": null,
                "used": false,
                "name": null,
                "teams": 0,
                "teamTime": "2024-05-11T13:00:23"
            }
        }
    ]
} as TStats
